import React from "react";
import { Button } from "react-md";
import successGif from "../../../../../../../assets/images/done-animation.gif";
import { Col, Row } from "react-flexbox-grid";
import EventService from "../../../../../../../service/event/EventService";

const SuccessWithGeneratedLink = ({
  onClose,
  paymentLinkBody,
  withCreateAppointment,
  appointmentCreated,
  appointment,
  props,
}) => {
  const paymentLink = paymentLinkBody?.link ?? "";
  const aptData = withCreateAppointment ? appointmentCreated : appointment;

  const handleCopy = () => {
    if (!paymentLink) return;
    navigator.clipboard.writeText(paymentLink);
    EventService.emit("showError", {
      message: "Link copied",
    });
  };

  return (
    <div className="pld-screen" style={{ textAlign: "center" }}>
      {/* SUCCESS GIF */}
      <div>
        <img src={successGif} alt="success" height="150px" />
      </div>

      {/* TITLE */}
      <div style={{ fontWeight: "bold", fontSize: "22px" }}>
        {withCreateAppointment
          ? "Appointment created successfully!"
          : "Payment link shared!"}
      </div>

      <br />

      <div>Payment link is successfully shared to user</div>

      {/* SENT TO BOX */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="show-shared-options-box zy-dashed-border">
          {paymentLinkBody?.sendWhatsapp && (
            <>
              <Row>
                <Col xs={6}>
                  <div style={{ fontWeight: "500", textAlign: "left" }}>
                    • Sent to Whatsapp
                  </div>
                </Col>
                <Col xs={6}>
                  <div
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "left",
                    }}
                  >
                    {`+${paymentLinkBody?.whatsappNo?.countryCode ?? ""} ${paymentLinkBody?.whatsappNo?.phoneNo ?? ""}`}
                  </div>
                </Col>
              </Row>

              <br />
            </>
          )}

          {paymentLinkBody?.sendEmail && (
            <>
              <Row>
                <Col xs={6}>
                  <div style={{ fontWeight: "500", textAlign: "left" }}>
                    • Sent to Email
                  </div>
                </Col>
                <Col xs={6}>
                  <div
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "left",
                      wordBreak: "break-all",
                      overflowWrap: "break-word",
                      lineHeight: "1.2",
                    }}
                  >
                    {paymentLinkBody?.emailAddress}
                  </div>
                </Col>
              </Row>
              <br />
            </>
          )}
          {paymentLinkBody?.sendSms && (
            <>
              <Row>
                <Col xs={6}>
                  <div style={{ fontWeight: "500", textAlign: "left" }}>
                    • Sms sent
                  </div>
                </Col>
                <Col xs={6}>
                  <div
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "left",
                    }}
                  >
                    {`+${paymentLinkBody?.smsNumber?.countryCode ?? ""} ${paymentLinkBody?.smsNumber?.phoneNo ?? ""}`}
                  </div>
                </Col>
              </Row>

              <br />
            </>
          )}
          {paymentLinkBody?.sendChat && (
            <>
              <Row>
                <Col xs={6}>
                  <div style={{ fontWeight: "500", textAlign: "left" }}>
                    • Sent to chat
                  </div>
                </Col>
                <Col xs={6}>
                  <div
                    style={{
                      fontWeight: "400",
                      color: "gray",
                      textAlign: "left",
                    }}
                  >
                    {`${aptData?.patientID ?? ""}`}
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>
      </div>

      <div className="zy-divider"></div>

      {/* NOTE */}
      <div>
        <span style={{ fontWeight: 600 }}>Please note:</span> This link will be
        valid for only {paymentLinkBody?.linkValidMins} mins, if payment is not
        made, the appointment will be cancelled at{" "}
        <span style={{ fontWeight: 600 }}>
          {paymentLinkBody?.expireAt
            ? new Date(paymentLinkBody.expireAt)
                .toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                })
                .toLowerCase()
            : ""}
        </span>
        .
      </div>

      <br />

      {/* PAYMENT LINK BOX */}
      <div className="payment-link-box">
        <div className="payment-link-label">Payment link:</div>

        <div className="payment-link-url">{paymentLinkBody?.link}</div>

        <div
          className={`payment-link-copy ${!paymentLinkBody?.link ? "disabled" : ""}`}
          onClick={handleCopy}
        >
          <i className="material-icons">content_copy</i>
        </div>
      </div>

      {/* BUTTON */}
      <div className="pld-center">
        <Button
          raised
          className="zy-btn-orange pld-main-btn"
          onClick={
            withCreateAppointment
              ? () => {
                  props.setView(2, {
                    appId: appointmentCreated?.id,
                  });
                }
              : onClose
          }
        >
          Done
        </Button>
      </div>
    </div>
  );
};

export default SuccessWithGeneratedLink;
